import { render, staticRenderFns } from "./newmagazine.vue?vue&type=template&id=37f55786&"
import script from "./newmagazine.vue?vue&type=script&lang=js&"
export * from "./newmagazine.vue?vue&type=script&lang=js&"
import style0 from "./newmagazine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports